import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { CSSProperties } from '../../../models/styles.interfaces';
import { BaseProperties } from '../../../models/ui.interfaces';
import { RadioSection } from './models/radio-section.interface';

@Component({
  selector: 'idp-radio-section',
  templateUrl: './radio-section.component.html',
  styleUrls: ['./radio-section.component.scss']
})
export class RadioSectionComponent
  implements BaseProperties<unknown, RadioSection, CSSProperties>
{
  @Input() content: RadioSection = {} as RadioSection;
  @Input() checked?: boolean;
  @Output() selected: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
  @Output()
  radioFocus: EventEmitter<FocusEvent> = new EventEmitter<FocusEvent>();

  constructor(private sanitizer: DomSanitizer) {}

  get subtitle() {
    return this.sanitizer.bypassSecurityTrustHtml(this.content.subtitle || '');
  }

  onSelected(event: MouseEvent): void {
    this.selected.emit(event);
  }

  onFocus(event: FocusEvent): void {
    this.radioFocus.emit(event);
  }
}
